export enum CheckpointType {
  Manual= 'ANY',
  Assignment = 'ZUT',
  Test = 'TEST',
  Development = 'ENTW'
}
